import React from 'react';

export default function HandshakeLogo({ className = "w-5 h-5" }) {
  return (
    <img
      src="/handshake-white.png"
      alt="SettledInFull"
      className={className}
      style={{ objectFit: 'contain' }}
      draggable={false}
    />
  );
}
